import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ModuleNameSpaces from '../ModuleNameSpaces';
import { UserPageAnnouncement } from '../../../services/AuthApiService';

/* --- STATE --- */
export interface State {
  loading: boolean;
  loaded: boolean;
  authenticated: boolean;
  isWorking: boolean;
  imageUrl: string | null;
  message: string | string[] | null;
  userPageAnnouncement: UserPageAnnouncement | null;
}

export const initialState: State = {
  loading: false,
  loaded: false,
  authenticated: false,
  isWorking: false,
  imageUrl: null,
  message: null,
  userPageAnnouncement: null,
};

const slice = createSlice({
  name: ModuleNameSpaces.Auth,
  initialState,
  reducers: {
    fetchAuthRequest: (state: State) => ({
      ...state,
      loading: true,
    }),
    fetchAuthSuccess: {
      reducer: (
        state: State,
        {
          payload: {
            authenticated,
            isWorking,
            imageUrl,
            message,
            userPageAnnouncement,
          },
        }: PayloadAction<{
          authenticated: boolean;
          isWorking: boolean;
          imageUrl: string | null;
          message: string | string[] | null;
          userPageAnnouncement: UserPageAnnouncement | null;
        }>,
      ) => ({
        ...state,
        loading: false,
        loaded: true,
        authenticated,
        isWorking,
        imageUrl,
        message,
        userPageAnnouncement: userPageAnnouncement || null,
      }),
      prepare: (
        authenticated: boolean,
        isWorking: boolean,
        imageUrl: string | null,
        message: string | string[] | null,
        userPageAnnouncement: UserPageAnnouncement | null = null,
      ) => ({
        payload: {
          authenticated,
          isWorking,
          imageUrl,
          message,
          userPageAnnouncement,
        },
      }),
    },
    fetchAuthFailure: (state: State) => ({
      ...state,
      loading: false,
      loaded: true,
    }),
  },
});

export const { reducer, actions } = slice;
